import { GeneralModel } from "./general.model";
import { Hub } from "./hub.model";

export class AreaGroup extends GeneralModel {
    hubId: number;
    hub: Hub;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/models/areaGroup.model.ts